import script from "./KeyDatesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyDatesCard.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/card-rizz.css?vue&type=style&index=0&id=7e20e8ec&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e20e8ec"]])

export default __exports__